import { doGoogleOauth } from 'actions/auth'
import { V3_EMAIL_PAGE, V3_COMPANY_PAGE } from '../pages'

export function doEmailSignup() {
  return dispatch => {
    dispatch({ type: V3_EMAIL_PAGE })
    return Promise.resolve()
  }
}

export function doGoogleSignup() {
  return dispatch => {
    return dispatch(
      doGoogleOauth(
        V3_COMPANY_PAGE,
        { signup: true },
        { rethrowErrorOnClosedPopup: true }
      )
    )
  }
}
